import script from "./PDFInvoiceDownload.vue?vue&type=script&lang=ts&setup=true"
export * from "./PDFInvoiceDownload.vue?vue&type=script&lang=ts&setup=true"

import "./PDFInvoiceDownload.vue?vue&type=style&index=0&id=65cfa466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65cfa466"]])

export default __exports__